import { Card } from "@dash/page";
import { useTheme } from "@emotion/react";
import React, { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  title: string;
  isOpen: boolean;
  onToggle: () => void;
}>;

export const CubeHomeAccordionSection: React.FC<Props> = ({ title, isOpen, onToggle, children }) => {
  const theme = useTheme();
  return (
    <Card variant="secondary" padding="0">
      <div css={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div
          role="button"
          tabIndex={0}
          onClick={onToggle}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onToggle();
            }
          }}
          css={{
            display: "flex",
            width: "100%",
            boxSizing: "border-box",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            padding: "0.65rem 1rem",
            cursor: "pointer",
            color: theme.colors.primary,
            fontSize: "1rem",
            fontWeight: 400,
            lineHeight: 1.3,
            outline: "none",
            ":focus-visible": {
              outline: `2px solid ${theme.colors.primary}`,
              outlineOffset: 2,
            },
          }}
        >
          <span css={{ flex: 1, minWidth: 0 }}>{title}</span>
          <span aria-hidden css={{ fontSize: "0.75rem", lineHeight: 1, color: theme.colors.primary, flexShrink: 0 }}>
            {isOpen ? "▼" : "▶"}
          </span>
        </div>
        {isOpen && (
          <div
            css={{
              padding: "0 1rem 1rem",
              color: "black",
            }}
          >
            {children}
          </div>
        )}
      </div>
    </Card>
  );
};
